import { useMemo, useState } from 'react'

//Styles
import Styles from './pilih-kantor-marketing-penjual.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import Order from 'pages/dashboard/e-reporting/forms/components/reuseables/order'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import SelectWithSearch from 'pages/dashboard/e-reporting/forms/components/reuseables/select-with-search/SelectWithSearch'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya/ButtonSelanjutnya'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Context
import { useERState } from "pages/dashboard/e-reporting/ERCtx";
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function PilihKantorMarketingPenjual() {
  //Context
  const { companies } = useERState()
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form, isEditing } = useFormState()

  //State
  const [selectedCompany, setSelectedCompany] = useState({
    ...form.kantor_marketing_penjual.value,
    value: form.kantor_marketing_penjual.value.id,
    label: form.kantor_marketing_penjual.value.name
  })

  const mappedCompanies = useMemo(() => {
    if (!companies?.data?.length) return [];
    return companies.data.map(company => {
      return {
        value: company.id,
        label: company.name,
        ...company
      }
    })
  }, [companies])

  const onNext = () => {
    handlePrevState()
    formHandler('kantor_marketing_penjual', selectedCompany)
    if (selectedCompany.id == 0) setCurrentStep(STEPS.tulisMarketingNonCentury)
    else setCurrentStep(STEPS.pilihMarketingPenjual)
  }

  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          Pilih kantor marketing penjual
        </TextMedium>

      </div>
      <div className={Styles['select-wrapper']}>
        <SelectWithSearch selectedData={selectedCompany} disabled={isAprroval || isEditing} onClick={setSelectedCompany} options={mappedCompanies} placeholder="Klik di sini atau klik simbol panah" />
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            {selectedCompany.id !== null ? <ButtonSelanjutnya onClick={onNext} /> : null}
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default PilihKantorMarketingPenjual
